import { createSlice } from "@reduxjs/toolkit";

export const appSettingsSlice = createSlice({
    name: 'appSettings',
    initialState: {
        value: {
            appid: null,
            branding: null,
            contact: null,
            contactHours: null,
            defaultURL: null,
            appid: null,
            CodeExpiry: null
        }
    },
    reducers: {
        setAppId: (state, action) => {
            state.value = {
                ...state.value,
                appid: action.payload
            }
        },
        setAppSettings: (state, action) => {
            state.value = {
                ...state.value,
                ...action.payload
            }
        }
    }
});

export const { setAppSettings, setAppId } = appSettingsSlice.actions;

export const selectAppSettings = state => state.appSettings.value;

export default appSettingsSlice.reducer;